import React, { Suspense, useContext } from "react";
import { IntlContext } from "context";
import Loader from "ui/Loader";

const Main: React.FC = ({ children }) => {
    const intl = useContext(IntlContext);

    return (
        <div className="root-container">
            <header className="topbar"></header>
            <main className="main">
                <Suspense fallback={<Loader message={intl.formatMessage("generic.loader.loading.label")} />}>
                    {children}
                </Suspense>
            </main>
        </div>
    );
};

export default Main;
